import { ThemeData } from '@y42/json-schema';

export const builtInThemes: Array<{
  themeName: string;
  theme: ThemeData;
}> = [
  {
    themeName: 'vintage',
    theme: {
      themeName: 'vintage',
      seriesCnt: 4,
      backgroundColor: '#fef8ef',
      frameBackgroundColor: '#fffbf5',
      frameBorderColor: '#aaaaaa',
      frameBorderWidth: 1,
      titleColor: '#333333',
      subtitleColor: '#aaa',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#ff0000',
      color: [
        '#d87c7c',
        '#919e8b',
        '#d7ab82',
        '#6e7074',
        '#61a0a8',
        '#efa18d',
        '#787464',
        '#cc7e63',
        '#724e58',
        '#4b565b',
      ],
      borderColor: '#d87c7c',
      borderWidth: 0,
      visualMapColor: ['#bf444c', '#d88273', '#f6efa6'],
      legendTextColor: '#333333',
      kColor: '#c23531',
      kColor0: '#314656',
      kBorderColor: '#c23531',
      kBorderColor0: '#314656',
      kBorderWidth: 1,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 1,
      lineSmooth: false,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#000000',
      mapLabelColorE: 'rgb(100,0,0)',
      mapBorderColor: '#444444',
      mapBorderColorE: '#444444',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#eeeeee',
      mapAreaColorE: '#ffd900',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999999',
      toolboxEmphasisColor: '#666666',
      tooltipAxisColor: '#cccccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#293c55',
      timelineLineWidth: 1,
      timelineItemColor: '#293c55',
      timelineItemColorE: '#a9334c',
      timelineCheckColor: '#e43c59',
      timelineCheckBorderColor: 'rgba(194,53,49,0.5)',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#293c55',
      timelineControlBorderColor: '#293c55',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#293c55',
      datazoomBackgroundColor: 'rgba(47,69,84,0)',
      datazoomDataColor: 'rgba(47,69,84,0.3)',
      datazoomFillColor: 'rgba(167,183,204,0.4)',
      datazoomHandleColor: '#a7b7cc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#333333',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#333333',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'dark',
    theme: {
      themeName: 'dark',
      seriesCnt: 4,
      backgroundColor: '#333333',
      frameBackgroundColor: '#444444',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#eeeeee',
      subtitleColor: '#aaa',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#eee',
      color: [
        '#dd6b66',
        '#759aa0',
        '#e69d87',
        '#8dc1a9',
        '#ea7e53',
        '#eedd78',
        '#73a373',
        '#73b9bc',
        '#7289ab',
        '#91ca8c',
        '#f49f42',
      ],
      borderColor: '#ccc',
      borderWidth: 0,
      visualMapColor: ['#bf444c', '#d88273', '#f6efa6'],
      legendTextColor: '#eeeeee',
      kColor: '#fd1050',
      kColor0: '#0cf49b',
      kBorderColor: '#fd1050',
      kBorderColor0: '#0cf49b',
      kBorderWidth: 1,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'circle',
      symbolBorderWidth: 1,
      lineSmooth: false,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#000',
      mapLabelColorE: 'rgb(100,0,0)',
      mapBorderColor: '#444',
      mapBorderColorE: '#444',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#eee',
      mapAreaColorE: 'rgba(255,215,0,0.8)',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#eeeeee',
          axisTickShow: true,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: false,
          splitLineColor: ['#aaaaaa'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#eeeeee',
          axisTickShow: true,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#eeeeee',
          axisTickShow: false,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#eeeeee',
          axisTickShow: false,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#eeeeee',
          axisTickShow: true,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999',
      toolboxEmphasisColor: '#666',
      tooltipAxisColor: '#eeeeee',
      tooltipAxisWidth: 1,
      timelineLineColor: '#eeeeee',
      timelineLineWidth: 1,
      timelineItemColor: '#dd6b66',
      timelineItemColorE: '#a9334c',
      timelineCheckColor: '#e43c59',
      timelineCheckBorderColor: '#c23531',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#eeeeee',
      timelineControlBorderColor: '#eeeeee',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#eeeeee',
      datazoomBackgroundColor: 'rgba(47,69,84,0)',
      datazoomDataColor: 'rgba(255,255,255,0.3)',
      datazoomFillColor: 'rgba(167,183,204,0.4)',
      datazoomHandleColor: '#a7b7cc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#eeeeee',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#eeeeee',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'westeros',
    theme: {
      themeName: 'westeros',
      seriesCnt: 4,
      backgroundColor: '#fafafa',
      frameBackgroundColor: '#ffffff',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#516b91',
      subtitleColor: '#93b7e3',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#eee',
      color: ['#516b91', '#59c4e6', '#edafda', '#93b7e3', '#a5e7f0', '#cbb0e3'],
      borderColor: '#516b91',
      borderWidth: 0,
      visualMapColor: ['#516b91', '#59c4e6', '#a5e7f0'],
      legendTextColor: '#999999',
      kColor: '#edafda',
      kColor0: 'transparent',
      kBorderColor: '#d680bc',
      kBorderColor0: '#8fd3e8',
      kBorderWidth: 2,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 2,
      lineSmooth: true,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#000',
      mapLabelColorE: '#516b91',
      mapBorderColor: '#516b91',
      mapBorderColorE: '#516b91',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#f3f3f3',
      mapAreaColorE: '#a5e7f0',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#cccccc',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#999999',
          splitLineShow: false,
          splitLineColor: ['#eeeeee'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999',
      toolboxEmphasisColor: '#666',
      tooltipAxisColor: '#ccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#8fd3e8',
      timelineLineWidth: 1,
      timelineItemColor: '#8fd3e8',
      timelineItemColorE: '#8fd3e8',
      timelineCheckColor: '#8fd3e8',
      timelineCheckBorderColor: 'rgba(138,124,168,0.37)',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#8fd3e8',
      timelineControlBorderColor: '#8fd3e8',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#8fd3e8',
      datazoomBackgroundColor: 'rgba(0,0,0,0)',
      datazoomDataColor: 'rgba(255,255,255,0.3)',
      datazoomFillColor: 'rgba(167,183,204,0.4)',
      datazoomHandleColor: '#a7b7cc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#333',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#999999',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'essos',
    theme: {
      themeName: 'essos',
      seriesCnt: 4,
      backgroundColor: '#fbfaef',
      frameBackgroundColor: '#fffef5',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#893448',
      subtitleColor: '#d95850',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#ffffff',
      color: ['#893448', '#d95850', '#eb8146', '#ffb248', '#f2d643', '#ebdba4'],
      borderColor: '#893448',
      borderWidth: 0,
      visualMapColor: ['#893448', '#d95850', '#eb8146', '#ffb248', '#f2d643', 'rgb(247,238,173)'],
      legendTextColor: '#999999',
      kColor: '#eb8146',
      kColor0: 'transparent',
      kBorderColor: '#d95850',
      kBorderColor0: '#58c470',
      kBorderWidth: 2,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 2,
      lineSmooth: true,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#893448',
      mapLabelColorE: '#893448',
      mapBorderColor: '#999999',
      mapBorderColorE: '#eb8146',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#f3f3f3',
      mapAreaColorE: '#ffb248',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#aaaaaa',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#999999',
          splitLineShow: false,
          splitLineColor: ['#e6e6e6'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999',
      toolboxEmphasisColor: '#666',
      tooltipAxisColor: '#ccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#893448',
      timelineLineWidth: 1,
      timelineItemColor: '#893448',
      timelineItemColorE: '#ffb248',
      timelineCheckColor: '#eb8146',
      timelineCheckBorderColor: '#ffb248',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#893448',
      timelineControlBorderColor: '#893448',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#893448',
      datazoomBackgroundColor: 'rgba(255,255,255,0)',
      datazoomDataColor: 'rgba(255,178,72,0.5)',
      datazoomFillColor: 'rgba(255,178,72,0.15)',
      datazoomHandleColor: '#ffb248',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#333',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#999999',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'wonderland',
    theme: {
      themeName: 'wonderland',
      seriesCnt: 3,
      backgroundColor: '#fafafa',
      frameBackgroundColor: '#ffffff',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#666666',
      subtitleColor: '#999999',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#ffffff',
      color: ['#4ea397', '#22c3aa', '#7bd9a5', '#d0648a', '#f58db2', '#f2b3c9'],
      borderColor: '#4ea397',
      borderWidth: 0,
      visualMapColor: ['#d0648a', '#22c3aa', '#adfff1'],
      legendTextColor: '#999999',
      kColor: '#d0648a',
      kColor0: 'transparent',
      kBorderColor: '#d0648a',
      kBorderColor0: '#22c3aa',
      kBorderWidth: 1,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 2,
      lineSmooth: false,
      graphLineWidth: 1,
      graphLineColor: '#cccccc',
      mapLabelColor: '#28544e',
      mapLabelColorE: '#349e8e',
      mapBorderColor: '#999999',
      mapBorderColorE: '#22c3aa',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#eeeeee',
      mapAreaColorE: 'rgba(34,195,170,0.25)',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#cccccc',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#999999',
          splitLineShow: false,
          splitLineColor: ['#eeeeee'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999999',
      toolboxEmphasisColor: '#666666',
      tooltipAxisColor: '#cccccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#4ea397',
      timelineLineWidth: 1,
      timelineItemColor: '#4ea397',
      timelineItemColorE: '#4ea397',
      timelineCheckColor: '#4ea397',
      timelineCheckBorderColor: '#3cebd2',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#4ea397',
      timelineControlBorderColor: '#4ea397',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#4ea397',
      datazoomBackgroundColor: 'rgba(255,255,255,0)',
      datazoomDataColor: 'rgba(222,222,222,1)',
      datazoomFillColor: 'rgba(114,230,212,0.25)',
      datazoomHandleColor: '#cccccc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#999999',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#999999',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'walden',
    theme: {
      themeName: 'walden',
      seriesCnt: 3,
      backgroundColor: '#fafafa',
      frameBackgroundColor: '#ffffff',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#666666',
      subtitleColor: '#999999',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#ffffff',
      color: ['#3fb1e3', '#6be6c1', '#626c91', '#a0a7e6', '#c4ebad', '#96dee8'],
      borderColor: '#3fb1e3',
      borderWidth: 0,
      visualMapColor: ['#2a99c9', '#afe8ff'],
      legendTextColor: '#999999',
      kColor: '#e6a0d2',
      kColor0: 'transparent',
      kBorderColor: '#e6a0d2',
      kBorderColor0: '#3fb1e3',
      kBorderWidth: 2,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 2,
      lineSmooth: false,
      graphLineWidth: 1,
      graphLineColor: '#cccccc',
      mapLabelColor: '#ffffff',
      mapLabelColorE: '#3fb1e3',
      mapBorderColor: '#aaaaaa',
      mapBorderColorE: '#3fb1e3',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#eeeeee',
      mapAreaColorE: 'rgba(63,177,227,0.25)',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#cccccc',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#999999',
          splitLineShow: false,
          splitLineColor: ['#eeeeee'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999999',
      toolboxEmphasisColor: '#666666',
      tooltipAxisColor: '#cccccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#626c91',
      timelineLineWidth: 1,
      timelineItemColor: '#626c91',
      timelineItemColorE: '#626c91',
      timelineCheckColor: '#3fb1e3',
      timelineCheckBorderColor: '#3fb1e3',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#626c91',
      timelineControlBorderColor: '#626c91',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#626c91',
      datazoomBackgroundColor: 'rgba(255,255,255,0)',
      datazoomDataColor: 'rgba(222,222,222,1)',
      datazoomFillColor: 'rgba(114,230,212,0.25)',
      datazoomHandleColor: '#cccccc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#999999',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#999999',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'chalk',
    theme: {
      themeName: 'chalk',
      seriesCnt: 3,
      backgroundColor: '#293441',
      frameBackgroundColor: '#394451',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#ffffff',
      subtitleColor: '#dddddd',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#293441',
      color: ['#fc97af', '#87f7cf', '#f7f494', '#72ccff', '#f7c5a0', '#d4a4eb', '#d2f5a6', '#76f2f2'],
      borderColor: '#ccc',
      borderWidth: 0,
      visualMapColor: ['#fc97af', '#87f7cf'],
      legendTextColor: '#ddd',
      kColor: '#fc97af',
      kColor0: 'transparent',
      kBorderColor: '#fc97af',
      kBorderColor0: '#87f7cf',
      kBorderWidth: 2,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'circle',
      symbolBorderWidth: 4,
      lineSmooth: true,
      graphLineWidth: 1,
      graphLineColor: '#ffffff',
      mapLabelColor: '#893448',
      mapLabelColorE: 'rgb(137,52,72)',
      mapBorderColor: '#999999',
      mapBorderColorE: '#eb8146',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#f3f3f3',
      mapAreaColorE: 'rgba(255,178,72,1)',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#666666',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#aaaaaa',
          splitLineShow: false,
          splitLineColor: ['#e6e6e6'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#ddd',
          axisTickShow: true,
          axisTickColor: '#ddd',
          axisLabelShow: true,
          axisLabelColor: '#ddd',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#ddd',
          axisTickShow: false,
          axisTickColor: '#ddd',
          axisLabelShow: true,
          axisLabelColor: '#ddd',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#ddd',
          axisTickShow: false,
          axisTickColor: '#ddd',
          axisLabelShow: true,
          axisLabelColor: '#ddd',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#ddd',
          axisTickShow: true,
          axisTickColor: '#ddd',
          axisLabelShow: true,
          axisLabelColor: '#ddd',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999999',
      toolboxEmphasisColor: '#666666',
      tooltipAxisColor: '#cccccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#87f7cf',
      timelineLineWidth: 1,
      timelineItemColor: '#87f7cf',
      timelineItemColorE: '#f7f494',
      timelineCheckColor: '#fc97af',
      timelineCheckBorderColor: '#fc97af',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#87f7cf',
      timelineControlBorderColor: '#87f7cf',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#87f7cf',
      datazoomBackgroundColor: 'rgba(255,255,255,0)',
      datazoomDataColor: 'rgba(114,204,255,1)',
      datazoomFillColor: 'rgba(114,204,255,0.2)',
      datazoomHandleColor: '#72ccff',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#333333',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#999999',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'infographic',
    theme: {
      themeName: 'infographic',
      seriesCnt: 4,
      backgroundColor: '#fafafa',
      frameBackgroundColor: '#ffffff',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#27727b',
      subtitleColor: '#aaa',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#eee',
      color: [
        '#c1232b',
        '#27727b',
        '#fcce10',
        '#e87c25',
        '#b5c334',
        '#fe8463',
        '#9bca63',
        '#fad860',
        '#f3a43b',
        '#60c0dd',
        '#d7504b',
        '#c6e579',
        '#f4e001',
        '#f0805a',
        '#26c0c0',
      ],
      borderColor: '#c1232b',
      borderWidth: 0,
      visualMapColor: ['#c1232b', '#fcce10'],
      legendTextColor: '#333333',
      kColor: '#c1232b',
      kColor0: '#b5c334',
      kBorderColor: '#c1232b',
      kBorderColor0: '#b5c334',
      kBorderWidth: 1,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 1,
      lineSmooth: false,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#c1232b',
      mapLabelColorE: 'rgb(100,0,0)',
      mapBorderColor: '#eeeeee',
      mapBorderColorE: '#444',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#dddddd',
      mapAreaColorE: '#fe994e',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#27727b',
          axisTickShow: true,
          axisTickColor: '#27727b',
          axisLabelShow: true,
          axisLabelColor: '#27727b',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#27727b',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#27727b',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#c1232b',
      toolboxEmphasisColor: '#e87c25',
      tooltipAxisColor: '#27727b',
      tooltipAxisWidth: 1,
      timelineLineColor: '#293c55',
      timelineLineWidth: 1,
      timelineItemColor: '#27727b',
      timelineItemColorE: '#72d4e0',
      timelineCheckColor: '#c1232b',
      timelineCheckBorderColor: '#c23531',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#27727b',
      timelineControlBorderColor: '#27727b',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#293c55',
      datazoomBackgroundColor: 'rgba(0,0,0,0)',
      datazoomDataColor: 'rgba(181,195,52,0.3)',
      datazoomFillColor: 'rgba(181,195,52,0.2)',
      datazoomHandleColor: '#27727b',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#999999',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#333333',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'macarons',
    theme: {
      themeName: 'macarons',
      seriesCnt: 4,
      backgroundColor: '#fafafa',
      frameBackgroundColor: '#ffffff',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#008acd',
      subtitleColor: '#aaa',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#eee',
      color: [
        '#2ec7c9',
        '#b6a2de',
        '#5ab1ef',
        '#ffb980',
        '#d87a80',
        '#8d98b3',
        '#e5cf0d',
        '#97b552',
        '#95706d',
        '#dc69aa',
        '#07a2a4',
        '#9a7fd1',
        '#588dd5',
        '#f5994e',
        '#c05050',
        '#59678c',
        '#c9ab00',
        '#7eb00a',
        '#6f5553',
        '#c14089',
      ],
      borderColor: '#2ec7c9',
      borderWidth: 0,
      visualMapColor: ['#5ab1ef', '#e0ffff'],
      legendTextColor: '#333333',
      kColor: '#d87a80',
      kColor0: '#2ec7c9',
      kBorderColor: '#d87a80',
      kBorderColor0: '#2ec7c9',
      kBorderWidth: 1,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 1,
      lineSmooth: true,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#d87a80',
      mapLabelColorE: 'rgb(100,0,0)',
      mapBorderColor: '#eeeeee',
      mapBorderColorE: '#444',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#dddddd',
      mapAreaColorE: 'rgba(254,153,78,1)',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#eeeeee',
          axisTickShow: true,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: false,
          splitLineColor: ['#aaaaaa'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#eee'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#008acd',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#eee'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#008acd',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#eee'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#008acd',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#eee'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#2ec7c9',
      toolboxEmphasisColor: '#18a4a6',
      tooltipAxisColor: '#008acd',
      tooltipAxisWidth: 1,
      timelineLineColor: '#008acd',
      timelineLineWidth: 1,
      timelineItemColor: '#008acd',
      timelineItemColorE: '#a9334c',
      timelineCheckColor: '#2ec7c9',
      timelineCheckBorderColor: '#2ec7c9',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#008acd',
      timelineControlBorderColor: '#008acd',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#008acd',
      datazoomBackgroundColor: 'rgba(47,69,84,0)',
      datazoomDataColor: '#efefff',
      datazoomFillColor: 'rgba(182,162,222,0.2)',
      datazoomHandleColor: '#008acd',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#333333',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#333333',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'roma',
    theme: {
      themeName: 'roma',
      seriesCnt: 4,
      backgroundColor: '#fafafa',
      frameBackgroundColor: '#ffffff',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#333333',
      subtitleColor: '#aaa',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#eee',
      color: [
        '#e01f54',
        '#001852',
        '#f5e8c8',
        '#b8d2c7',
        '#c6b38e',
        '#a4d8c2',
        '#f3d999',
        '#d3758f',
        '#dcc392',
        '#2e4783',
        '#82b6e9',
        '#ff6347',
        '#a092f1',
        '#0a915d',
        '#eaf889',
        '#6699FF',
        '#ff6666',
        '#3cb371',
        '#d5b158',
        '#38b6b6',
      ],
      borderColor: '#e01f54',
      borderWidth: 0,
      visualMapColor: ['#e01f54', '#e7dbc3'],
      legendTextColor: '#333333',
      kColor: '#e01f54',
      kColor0: '#001852',
      kBorderColor: '#f5e8c8',
      kBorderColor0: '#b8d2c7',
      kBorderWidth: 1,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 1,
      lineSmooth: false,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#000000',
      mapLabelColorE: 'rgb(100,0,0)',
      mapBorderColor: '#444444',
      mapBorderColorE: '#444',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#eeeeee',
      mapAreaColorE: 'rgba(255,215,0,0.8)',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999999',
      toolboxEmphasisColor: '#666666',
      tooltipAxisColor: '#cccccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#293c55',
      timelineLineWidth: 1,
      timelineItemColor: '#293c55',
      timelineItemColorE: '#a9334c',
      timelineCheckColor: '#e43c59',
      timelineCheckBorderColor: '#c23531',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#293c55',
      timelineControlBorderColor: '#293c55',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#293c55',
      datazoomBackgroundColor: 'rgba(47,69,84,0)',
      datazoomDataColor: 'rgba(47,69,84,0.3)',
      datazoomFillColor: 'rgba(167,183,204,0.4)',
      datazoomHandleColor: '#a7b7cc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#333333',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#333333',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'shine',
    theme: {
      themeName: 'shine',
      seriesCnt: 4,
      backgroundColor: '#fafafa',
      frameBackgroundColor: '#ffffff',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#333333',
      subtitleColor: '#aaa',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#eee',
      color: ['#c12e34', '#e6b600', '#0098d9', '#2b821d', '#005eaa', '#339ca8', '#cda819', '#32a487'],
      borderColor: '#c12e34',
      borderWidth: 0,
      visualMapColor: ['#1790cf', '#a2d4e6'],
      legendTextColor: '#333333',
      kColor: '#c12e34',
      kColor0: '#2b821d',
      kBorderColor: '#c12e34',
      kBorderColor0: '#2b821d',
      kBorderWidth: 1,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 1,
      lineSmooth: false,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#c12e34',
      mapLabelColorE: '#c12e34',
      mapBorderColor: '#eee',
      mapBorderColorE: '#ddd',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#ddd',
      mapAreaColorE: '#e6b600',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#333',
          axisTickShow: false,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#333',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#333',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#06467c',
      toolboxEmphasisColor: '#4187c2',
      tooltipAxisColor: '#cccccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#005eaa',
      timelineLineWidth: 1,
      timelineItemColor: '#005eaa',
      timelineItemColorE: '#005eaa',
      timelineCheckColor: '#005eaa',
      timelineCheckBorderColor: '#316bc2',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#005eaa',
      timelineControlBorderColor: '#005eaa',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#005eaa',
      datazoomBackgroundColor: 'rgba(47,69,84,0)',
      datazoomDataColor: 'rgba(47,69,84,0.3)',
      datazoomFillColor: 'rgba(167,183,204,0.4)',
      datazoomHandleColor: '#a7b7cc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#333333',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#333333',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'purple-passion',
    theme: {
      themeName: 'purple-passion',
      seriesCnt: 3,
      backgroundColor: '#5b5c6e',
      frameBackgroundColor: '#6b6c7e',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#ffffff',
      subtitleColor: '#cccccc',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#eee',
      color: ['#9b8bba', '#e098c7', '#8fd3e8', '#71669e', '#cc70af', '#7cb4cc'],
      borderColor: '#ccc',
      borderWidth: 0,
      visualMapColor: ['#8a7ca8', '#e098c7', '#cceffa'],
      legendTextColor: '#cccccc',
      kColor: '#e098c7',
      kColor0: 'transparent',
      kBorderColor: '#e098c7',
      kBorderColor0: '#8fd3e8',
      kBorderWidth: 2,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'circle',
      symbolBorderWidth: 2,
      lineSmooth: true,
      graphLineWidth: 1,
      graphLineColor: '#aaa',
      mapLabelColor: '#000',
      mapLabelColorE: '#ffffff',
      mapBorderColor: '#444',
      mapBorderColorE: '#444',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#eee',
      mapAreaColorE: '#e098c7',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#cccccc',
          axisTickShow: true,
          axisTickColor: '#333',
          axisLabelShow: true,
          axisLabelColor: '#cccccc',
          splitLineShow: false,
          splitLineColor: ['#eeeeee', '#dddddd'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#eeeeee',
          axisTickShow: true,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: false,
          splitLineColor: ['#eeeeee', '#dddddd'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#eeeeee',
          axisTickShow: false,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: true,
          splitLineColor: ['#eeeeee', '#dddddd'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#eeeeee',
          axisTickShow: false,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: true,
          splitLineColor: ['#eeeeee', '#dddddd'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#eeeeee',
          axisTickShow: true,
          axisTickColor: '#eeeeee',
          axisLabelShow: true,
          axisLabelColor: '#eeeeee',
          splitLineShow: false,
          splitLineColor: ['#eeeeee', '#dddddd'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999',
      toolboxEmphasisColor: '#666',
      tooltipAxisColor: '#ccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#8fd3e8',
      timelineLineWidth: 1,
      timelineItemColor: '#8fd3e8',
      timelineItemColorE: '#8fd3e8',
      timelineCheckColor: '#8fd3e8',
      timelineCheckBorderColor: '#8a7ca8',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#8fd3e8',
      timelineControlBorderColor: '#8fd3e8',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#8fd3e8',
      datazoomBackgroundColor: 'rgba(0,0,0,0)',
      datazoomDataColor: 'rgba(255,255,255,0.3)',
      datazoomFillColor: 'rgba(167,183,204,0.4)',
      datazoomHandleColor: '#a7b7cc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#333',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#cccccc',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
  {
    themeName: 'halloween',
    theme: {
      themeName: 'halloween',
      seriesCnt: 4,
      backgroundColor: '#9f9f9f',
      frameBackgroundColor: '#8f8f8f',
      frameBorderColor: '#cccccc',
      frameBorderWidth: 1,
      titleColor: '#ffaf51',
      subtitleColor: '#eeeeee',
      textColorShow: false,
      textColor: '#333',
      markTextColor: '#333333',
      color: ['#ff715e', '#ffaf51', '#ffee51', '#8c6ac4', '#715c87'],
      borderColor: '#ccc',
      borderWidth: 0,
      visualMapColor: ['#ff715e', '#ffee51', '#797fba'],
      legendTextColor: '#fff',
      kColor: '#ffee51',
      kColor0: 'rgba(255,255,255,0)',
      kBorderColor: '#ff715e',
      kBorderColor0: '#797fba',
      kBorderWidth: 1,
      lineWidth: 2,
      symbolSize: 4,
      symbol: 'emptyCircle',
      symbolBorderWidth: 2,
      lineSmooth: false,
      graphLineWidth: 1,
      graphLineColor: '#888888',
      mapLabelColor: '#ffffff',
      mapLabelColorE: '#ffee51',
      mapBorderColor: '#999999',
      mapBorderColorE: '#ffaf51',
      mapBorderWidth: 0.5,
      mapBorderWidthE: 1,
      mapAreaColor: '#555555',
      mapAreaColorE: 'rgba(255,175,81,0.5)',
      axes: [
        {
          type: 'all',
          name: '通用坐标轴',
          axisLineShow: true,
          axisLineColor: '#fff',
          axisTickShow: true,
          axisTickColor: '#fff',
          axisLabelShow: true,
          axisLabelColor: '#fff',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: true,
          splitAreaColor: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'category',
          name: '类目坐标轴',
          axisLineShow: true,
          axisLineColor: '#fff',
          axisTickShow: true,
          axisTickColor: '#fff',
          axisLabelShow: true,
          axisLabelColor: '#fff',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'value',
          name: '数值坐标轴',
          axisLineShow: false,
          axisLineColor: '#fff',
          axisTickShow: false,
          axisTickColor: '#fff',
          axisLabelShow: true,
          axisLabelColor: '#fff',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'log',
          name: '对数坐标轴',
          axisLineShow: false,
          axisLineColor: '#fff',
          axisTickShow: false,
          axisTickColor: '#fff',
          axisLabelShow: true,
          axisLabelColor: '#fff',
          splitLineShow: true,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
        {
          type: 'time',
          name: '时间坐标轴',
          axisLineShow: true,
          axisLineColor: '#fff',
          axisTickShow: true,
          axisTickColor: '#fff',
          axisLabelShow: true,
          axisLabelColor: '#fff',
          splitLineShow: false,
          splitLineColor: ['#ccc'],
          splitAreaShow: false,
          splitAreaColor: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)'],
          splitLineWidth: 1,
          axisLineWidth: 1,
        },
      ],
      axisSeperateSetting: true,
      toolboxColor: '#999999',
      toolboxEmphasisColor: '#666666',
      tooltipAxisColor: '#cccccc',
      tooltipAxisWidth: 1,
      timelineLineColor: '#ffaf51',
      timelineLineWidth: 1,
      timelineItemColor: '#ffaf51',
      timelineItemColorE: '#ffaf51',
      timelineCheckColor: '#ff715e',
      timelineCheckBorderColor: '#ff715e',
      timelineItemBorderWidth: 1,
      timelineControlColor: '#ffaf51',
      timelineControlBorderColor: '#ffaf51',
      timelineControlBorderWidth: 0.5,
      timelineLabelColor: '#ff715e',
      datazoomBackgroundColor: 'rgba(255,255,255,0)',
      datazoomDataColor: 'rgba(222,222,222,1)',
      datazoomFillColor: 'rgba(255,113,94,0.2)',
      datazoomHandleColor: '#cccccc',
      datazoomHandleWidth: '100',
      datazoomLabelColor: '#666666',
      agGridMaterialPrimaryColor: '#777777',
      agGridMaterialAccentColor: '#777777',
      agGridForegroundColor: '#666666',
      cohortPrimaryColor: '#62BE7B',
      cohortSecoundaryColor: '#F8696B',
    },
  },
];
